import { useState } from "react";
import Loader from "../../loader";
import { useDispatch, useSelector } from "react-redux";
import TableHeader from "../../table/tableHeader";
import NoRecord from "../../form/NoRecord";
import PaginationDropdown from "../../table/PaginationDropdown";
import ReactPagination from "../../table/ReactPagination";
import { curSym } from "../../../utils/pip";
import OfferDetails from "./modals/OfferDetails";
import { useLocation } from "react-router-dom";
import { coachPaths } from "../../../routes/coach";
import CreateOfferModal from "../../Modals/common/coachOffer/createOfferModal";
import {
  deleteOffer,
  fetchAllCoachOffers,
} from "../../../redux/features/coach/actions/coachAction";
import ConfirmationModal from "../../Modals/common/webinar/ConfirmationModal";
import EditOfferModal from "../../Modals/common/coachOffer/editOfferModal";

const Offers = ({ accountInformation, data = [] }) => {
  const dispatch = useDispatch();
  const [id, setId] = useState();
  const { pathname } = useLocation();
  const [isCreateOffer, setIsCreateOffer] = useState(false);
  const [isModal, setIsModal] = useState(false);
  const [activeOffer, setActiveOffer] = useState(null);
  const [isEditModal, setIsEditModal] = useState(false);

  const { subLoading } = useSelector((state) => state.freelancer.auth);

  const [currentPage, setCurrentPage] = useState(0);
  const [listPerPages, setListPerPages] = useState(5);

  const paginatedList = data?.slice(
    currentPage * listPerPages,
    (currentPage + 1) * listPerPages
  );

  const handlePageClick = (data) => {
    setCurrentPage(data?.selected);
  };

  const handleDeleteOffer = () => {
    const callback = (res) => {
      if (res?.success) {
        dispatch(fetchAllCoachOffers());
      }
    };
    dispatch(deleteOffer({ payload: id, callback }));
  };

  if (subLoading) {
    return <Loader />;
  };
  return (
    <div
      class={`tab-pane fade ${accountInformation == "Offers" && "show active"}`}
      id="v-pills-Offers"
      role="tabpanel"
      aria-labelledby="v-pills-Offers-tab"
    >
      <div className="">
        <div className="mb-4 d-flex align-items-center justify-content-between">
          <h6 className="ct_fs_18 mb-0">Offers</h6>
          {pathname == coachPaths?.CoachSettings && (
            <button
              className="ct_yellow_btn ct_sky_blue_btn ct_h_44"
              onClick={() => setIsCreateOffer(true)}
            >
              <i className="fa-solid fa-plus ct_fs_14 me-1"></i> Create Offer
            </button>
          )}
        </div>
        <div class="table-responsive ct_custom_table ct_custom_table2 pt-2">
          <table class="table">
            <TableHeader
              data={[
                "#",
                "Offer Title",
                "Purpose",
                "Type",
                "Duration",
                "Format",
                "Price",
                "Action",
              ]}
            />

            {paginatedList?.length > 0 && (
              <tbody>
                {paginatedList?.map((item, index) => (
                  <tr>
                    <td>{index + 1}</td>
                    <td className="text-capitalize">
                      {item?.offer_title || "#N/A"}{" "}
                    </td>
                    <td>
                      <span className="ct_pverlay_text d-inline-block">
                        {item?.purpose || "#N/A"}
                      </span>
                    </td>
                    <td>{item?.offer_type || "#N/A"}</td>
                    <td>{item?.duration || 0} minutes</td>
                    <td className="text-capitalize">
                      {" "}
                      {item?.offer_format || "#N/A"}{" "}
                    </td>
                    <td>
                      {curSym}
                      {item?.price || 0}{" "}
                    </td>
                    <td>
                      <div class="ct_right_dropdown dropdown">
                        {pathname == coachPaths?.CoachSettings ? (
                          <>
                            <button
                              id="dropdownMenuButton"
                              class="px-0"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                            >
                              <i class="fa-solid fa-ellipsis-vertical"></i>
                            </button>

                            <ul
                              class="dropdown-menu"
                              aria-labelledby="dropdownMenuButton1"
                            >
                              <li>
                                <a
                                  class="dropdown-item"
                                  href="#"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setActiveOffer(item);
                                    setIsModal(true);
                                  }}
                                >
                                  View Details
                                </a>
                              </li>
                              <li>
                                <a
                                  class="dropdown-item"
                                  href="#"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setActiveOffer(item);
                                    setIsEditModal(true);
                                  }}
                                >
                                  Edit
                                </a>
                              </li>

                              <li>
                                <a
                                  onClick={() => setId(item?.offer_id)}
                                  data-bs-target="#ct_remove_offer"
                                  data-bs-toggle="modal"
                                  class="dropdown-item ct_red_text"
                                  href="javascript:void(0)"
                                >
                                  Remove
                                </a>
                              </li>
                            </ul>
                          </>
                        ) : (
                          <i
                            style={{
                              cursor: "pointer",
                            }}
                            onClick={() => {
                              setActiveOffer(item);
                              setIsModal(true);
                            }}
                            class="fa-solid fa-eye"
                          ></i>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            )}
          </table>
          {paginatedList?.length <= 0 && <NoRecord />}
        </div>
        {paginatedList?.length != 0 && (
          <div className="d-flex justify-content-between align-items-center mt-4 ">
            <div>
              {pathname != coachPaths?.CoachSettings && (
                <PaginationDropdown
                  onChange={(val) => {
                    setListPerPages(val);
                    setCurrentPage(0);
                  }}
                />
              )}
            </div>
            <div>
              <ReactPagination
                pageCount={Math.ceil(data?.length / listPerPages)}
                onPageChange={handlePageClick}
                currentPage={currentPage}
              />
            </div>
          </div>
        )}
      </div>

      <OfferDetails
        isModal={isModal}
        setIsModal={setIsModal}
        data={activeOffer}
      />
      <ConfirmationModal
        id="ct_remove_offer"
        title="Delete Offer"
        onConfirm={handleDeleteOffer}
      />
      {isCreateOffer && (
        <CreateOfferModal
          onClose={() => {
            setIsCreateOffer(false);
            dispatch(fetchAllCoachOffers());
          }}
          dispatch={dispatch}
        />
      )}
      {isEditModal && (
        <EditOfferModal
          onClose={() => {
            setIsEditModal(false);
          }}
          data={activeOffer}
          dispatch={dispatch}
        />
      )}
    </div>
  );
};

export default Offers;
